import React from 'react';
import usePropertyPath, { PropertyPathStackProvider } from '../hooks/usePropertyPath';
import useProperty from '../hooks/useProperty';
import DynamicContentRenderer from '../DynamicContentRenderer';
import { HelpBox } from 'components/v2/help-boxes';
import WizardAddButton from 'components/v2/epd-wizard-inputs/WizardAddButton';
import { HeaderCaptionSemiBold, HorizontalDivider } from 'styles/v2/Styles.styled';
import { DeleteProductIconButton } from 'components/v2/compiler/ProductInformationTab';
import FontIcon from 'components/icons/FontIcon';

const ManufacturingSitesListRenderer: React.FC<any> = ({ propertyId, siteHeadingText, addMoreHelpText, children }) => {
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isDisabled } = useProperty<Record<string, any>[]>(propertyPath);

  return (
    <>
      {value.map((site, i, arr) => (
        <React.Fragment key={i}>
          {arr.length >= 2 && (
            <>
              {i >= 1 && <HorizontalDivider />}
              <div className="flex justify-content-between">
                <HeaderCaptionSemiBold>
                  {siteHeadingText} {i + 1}
                </HeaderCaptionSemiBold>
                {!isDisabled && (
                  <DeleteProductIconButton
                    icon={<FontIcon style={{ fontSize: '0.75rem' }} icon="delete" />}
                    text
                    onClick={() => setValue(value.filter((v) => v !== site))}
                  />
                )}
              </div>
            </>
          )}
          <PropertyPathStackProvider pushPath={[propertyId, i]}>
            <DynamicContentRenderer schema={children} />
          </PropertyPathStackProvider>
        </React.Fragment>
      ))}

      {!isDisabled && (
        <div>
          <HelpBox>{addMoreHelpText}</HelpBox>
          <WizardAddButton label="+ Address" onClick={() => setValue([...value, {}])} />
        </div>
      )}
    </>
  );
};

export default ManufacturingSitesListRenderer;
